import { store } from 'store/configureStore';

export const getAuthToken = () => {
    return store.getState()?.auth.token;
};

export const getAuthWellFunnelToken = () => {
    return store.getState()?.auth.tokenWellFunnel;
};

export const getAuthTokenRefresh = () => {
    return store.getState()?.auth.tokenRefresh;
};
